import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './views/Login'
import Logout from "./views/Logout";

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Login',
		component: Login
	},
	{
		path: '/logout',
		name: 'Logout',
		component: Logout
	},
	{
		path: '/home',
		name: 'Home',
		component: () => import("./views/Home")
	},
	{
		path: '/info',
		name: 'Info',
		component: () => import("./views/BottleInfo"),
	},
	{
		path: '/edit/:bid',
		name: 'Edit',
		component: () => import("./views/BottleEdit")
	},
	
	// GH bringt Flaschen
	{
		path: '/entered_storage/properties',
		name: 'Prepare Check in',
		component: () => import("./views/entered_storage/ChooseBottleProperties"),
	},
	{
		path: '/entered_storage/properties/scanner',
		name: 'Scanner Flaschen Check in',
		component: () => import("./views/entered_storage/Scanner"),
	},
	
	// Flaschen abgeben
	{
		path: '/at_customer/scanner',
		name: 'Scanner Flaschen abgeben',
		component: () => import("./views/at_customer/Scanner")
	},
	{
		path: '/at_customer/scanner/customer',
		name: 'Kunde zur Scannerauswahl',
		component: () => import("./views/at_customer/ChooseCustomer")
	},
	
	// Flaschen abholen
	{
		path: '/from_customer/customer',
		name: 'Scanner Flaschen abgeben',
		component: () => import("./views/from_customer/ChooseCustomer")
	},
	{
		path: '/from_customer/customer/scanner',
		name: 'Scanner',
		component: () => import("./views/from_customer/Scanner")
	},
	
	// Admin
	{
		path: '/admin',
		component: () => import("./views/admin/Admin"),
		children: [
			{path: '/admin', redirect: '/admin/bottles'},
			{
				path: '/admin/bottles',
				name: 'Bottles',
				component: () => import("./views/admin/BottleList")
			},
			{
				path: '/admin/bottles/:bottle_id',
				name: 'Bottle',
				props: true,
				component: () => import("./views/admin/BottleDetail")
			},
			{
				path: '/admin/bottles/:bottle_id/edit',
				name: 'Bottle',
				props: true,
				component: () => import("./views/admin/BottleEdit")
			},
			{
				path: '/admin/bottles/add/new',
				name: 'Bottles',
				component: () => import("./views/admin/BottleAdd")
			},
			{
				path: '/admin/customers',
				name: 'Customers',
				component: () => import("./views/admin/CustomerList")
			},
			{
				path: '/admin/customers/:customer_id',
				name: 'Customer',
				component: () => import("./views/admin/CustomerDetail")
			},
			{
				path: '/admin/customers/:customer_id/edit',
				name: 'Customer',
				component: () => import("./views/admin/CustomerEdit")
			},
			{
				path: '/admin/customers/add/new',
				name: 'Customer',
				component: () => import("./views/admin/CustomerAdd")
			},
			{
				path: '/admin/users',
				name: 'Users',
				component: () => import("./views/admin/UserList")
			},
			{
				path: '/admin/users/:user_id',
				name: 'User',
				component: () => import("./views/admin/UserDetail")
			},
			{
				path: '/admin/users/:user_id/edit',
				name: 'User',
				component: () => import("./views/admin/UserEdit")
			},
			{
				path: '/admin/users/add/new',
				name: 'User',
				component: () => import("./views/admin/UserAdd")
			},
		]
	},

];

const router = new VueRouter({
	routes
});

export default router
